var map = {
	"./emoticon-csat-1-on.svg": "d8fe",
	"./emoticon-csat-2-on.svg": "349b",
	"./emoticon-csat-3-on.svg": "9215",
	"./emoticon-csat-4-on.svg": "7c46",
	"./emoticon-csat-5-on.svg": "c45b",
	"./emoticon-nps-0-on.svg": "c0d8",
	"./emoticon-nps-1-on.svg": "d59f",
	"./emoticon-nps-10-on.svg": "b056",
	"./emoticon-nps-2-on.svg": "1085",
	"./emoticon-nps-3-on.svg": "0e0a",
	"./emoticon-nps-4-on.svg": "7182",
	"./emoticon-nps-5-on.svg": "5cf7",
	"./emoticon-nps-6-on.svg": "e8fa",
	"./emoticon-nps-7-on.svg": "655c",
	"./emoticon-nps-8-on.svg": "59be",
	"./emoticon-nps-9-on.svg": "f7e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8bd1";